import { PLAY_MODE, SET_LEVEL_MODE } from '../enums';
import { i18nConfig } from '../i18n';
import { t } from '../util';
import { runValidators, VALIDATE_PASS_RESULT } from '../util/validator';
import { checkUrlConfigVailed, compareUrlConfig } from './play-helper';
var i18nCore = i18nConfig.core;
/**
 * basePlayer播放状态检查类
 */
var CheckPlayerStatus = /** @class */ (function () {
    function CheckPlayerStatus(player) {
        var _this = this;
        this.setLevelValidator = {
            NOT_INITIALIZED: function () {
                if (!_this.player) {
                    return { isValid: false, message: t(i18nCore.ERROR_STATUS_NOT_INITIALIZED) };
                }
                return VALIDATE_PASS_RESULT;
            },
            NOT_PLAYING: function () {
                if (!_this.player.played) {
                    return { isValid: false, message: t(i18nCore.ERROR_STATUS_NOT_PLAYING) };
                }
                return VALIDATE_PASS_RESULT;
            },
            EMPTY_URL: function (setLevelUrl) {
                if (!setLevelUrl) {
                    return { isValid: false, message: t(i18nCore.ERROR_STATUS_EMPTY_URL) };
                }
                return VALIDATE_PASS_RESULT;
            },
            EMPTY_VIDEO_INFO: function () {
                if (!_this.player.currentVideoInfo) {
                    return { isValid: false, message: t(i18nCore.ERROR_STATUS_VIDEO_INFO) };
                }
                return VALIDATE_PASS_RESULT;
            },
            PLAYTIME_CHECK: function () {
                if (_this.player.currentVideoInfo.playtime <= 0) {
                    return { isValid: false, message: t(i18nCore.ERROR_STATUS_PLAYTIME_CHECK) };
                }
                return VALIDATE_PASS_RESULT;
            },
            CLOSE_TO_END: function () {
                var videoInfo = _this.player.currentVideoInfo;
                if (_this.player.config.type === PLAY_MODE.VOD
                    && videoInfo.playtime + 1 >= videoInfo.duration
                    && videoInfo.duration !== Infinity) {
                    return { isValid: false, message: t(i18nCore.ERROR_STATUS_CLOSE_TO_END) };
                }
                return VALIDATE_PASS_RESULT;
            },
            TARGET_NOT_CHANGE: function (setLevelUrl) {
                var currentVideoInfo = _this.player.currentVideoInfo;
                if (setLevelUrl === currentVideoInfo.loadingUrl) {
                    return { isValid: false, message: t(i18nCore.ERROR_STATUS_TARGET_UNCHANGED) };
                }
                return VALIDATE_PASS_RESULT;
            },
        };
        this.player = player;
    }
    /**
     * 默认选择清晰度切换模式
     * @param vnlistLen videoNode列表个数
     * @param forceSetLevelMode 外部强制指定的清晰度切换模式
     * @returns 清晰度切换模式
     */
    CheckPlayerStatus.prototype.checkSetLevelMode = function (vnlistLen, forceSetLevelMode) {
        if (vnlistLen < 2) {
            // 如果小于两个video标签，只能黑屏切换清晰度
            return SET_LEVEL_MODE.HARD;
        }
        if (forceSetLevelMode) {
            return forceSetLevelMode;
        }
        return SET_LEVEL_MODE.SOFT;
    };
    /**
     * 检测是否当前满足append环境条件
     * @param urlConfig 待append的视频URL对象
     * @returns {canAppend:boolean,message:string}canAppend表示是否支持Append，message表示具体信息描述和不能append原因
     */
    CheckPlayerStatus.prototype.checkCanAppend = function (urlConfig) {
        var _a;
        // basePlayer或相关配置为空，不能拼接或者预加载
        if (!((_a = this.player) === null || _a === void 0 ? void 0 : _a.config)) {
            return {
                canAppend: false,
                message: 'BasePlayer or basePlayer.config is null',
            };
        }
        // 如果不是List播放，不能拼接或者预加载
        if (!this.player.config.isPlayList) {
            return {
                canAppend: false,
                message: 'Only supported when [isPlayList] is true',
            };
        }
        // 如果尚未起播过，不能拼接或者预加载
        if (!this.player.played) {
            return {
                canAppend: false,
                message: 'Player has not been played',
            };
        }
        // 检查UrlConfig作为参数时是否是合法的，如果返回错误，也不能拼接或者预加载
        var checkUrlConfigError = checkUrlConfigVailed(urlConfig, this.player.kernelName);
        if (checkUrlConfigError) {
            return {
                canAppend: false,
                message: "urlconfig err=".concat(checkUrlConfigError),
            };
        }
        return {
            canAppend: true,
            message: 'Can append video now',
        };
    };
    /**
     * 检测是否当前满足preload环境条件
     * @param urlConfigs 待preload的视频UrlConfig数组对象
     * @returns {canPreload:boolean,message:string}canPreload表示是否支持preload，message表示具体信息描述和不能preload原因
     */
    CheckPlayerStatus.prototype.checkCanPreloadEnvi = function (urlConfigs) {
        // 判断条件与checkCanAppend相同，复用逻辑
        var preloadDetail = this.checkCanAppend(urlConfigs);
        if (!preloadDetail.canAppend) {
            return {
                canPreload: false,
                message: preloadDetail.message,
            };
        }
        // 继承是否支持逻辑判断
        if (!this.player.supportPreload) {
            return {
                canPreload: false,
                message: 'preloadNext() fail, browser not support preload.',
            };
        }
        return {
            canPreload: true,
            message: 'Can preload video now',
        };
    };
    /**
     * 检查单个UrlConfig是否当前满足preload播放条件
     * @param urlConfig 待preload的视频URL对象
     * @returns {canPreload:boolean,message:string}canPreload表示是否支持preload，message表示具体信息描述和不能preload原因
     */
    CheckPlayerStatus.prototype.checkCanPreloadEachConfig = function (urlConfig) {
        var _a;
        if (!((_a = this.player) === null || _a === void 0 ? void 0 : _a.videoInfos)) {
            return {
                canPreload: false,
                message: 'preloadInner() fail, because player or videoInfo is null.',
            };
        }
        var idx = this.player.videoInfos.findIndex(function (value) { return compareUrlConfig(value.config, urlConfig); });
        // 已经播放过了，没必要预加载了
        if (idx !== -1 && idx <= this.player.curUrlIdx) {
            return {
                canPreload: false,
                message: 'preloadInner() fail, because this videoInfo has been played.',
            };
        }
        // 如果跨过下一个视频预加载下下个，或者下下下个视频，是不允许的
        if (idx !== -1 && idx > this.player.curUrlIdx + 1) {
            return {
                canPreload: false,
                message: 'preloadInner() fail, can not skip next to preload.',
            };
        }
        // 如果列表中有下一个播放地址，而预加载的又不是下一个，那就没必要了吧
        // 如果basePlayer.nextVideoInfo为空，可能存在新的视频信息逻辑，所以此处nextVideoInfo必须存在
        if (this.player.nextVideoInfo && !compareUrlConfig(this.player.nextVideoInfo.config, urlConfig)) {
            return {
                canPreload: false,
                message: 'preloadInner() fail, the next has been appended, you only can preload next.',
            };
        }
        // 已经在预加载列表中了
        var index = this.player.preloadVideoInfos.findIndex(function (value) { return compareUrlConfig(value.config, urlConfig); });
        var hasPreload = index !== -1;
        if (hasPreload) {
            return {
                canPreload: false,
                message: 'preloadInner() fail, the VideoInfo has been preloaded.',
            };
        }
        return {
            canPreload: true,
            message: 'Can preload video now',
        };
    };
    /**
     * 判断当前播放器切换清晰度外在条件是否满足，并返回对应信息（展示在tips上）
     * @param levelUrl 切换的目标URL
     * @returns 返回描述信息，如果为null代表满足条件
     */
    CheckPlayerStatus.prototype.checkSetLevelError = function (levelUrl) {
        var validateResult = runValidators(Object.values(this.setLevelValidator), function (validatorRunner) { return validatorRunner(levelUrl); });
        if (!validateResult.isValid) {
            return validateResult.message;
        }
        return null;
    };
    /**
     * 检查列表播放是否需要继续播放下一个视频
     * @returns {canPlayNext:boolean,message:string} 是否可以继续播放下一个视频
     */
    CheckPlayerStatus.prototype.checkCanPlayNext = function () {
        var _a;
        if (!((_a = this.player) === null || _a === void 0 ? void 0 : _a.videoInfos)) {
            return {
                canPlayNext: false,
                message: 'Player or player.videoInfo is null',
            };
        }
        if (!this.player.played) {
            return {
                canPlayNext: false,
                message: 'Player has not been played',
            };
        }
        if (!this.player.nextVideoInfo) {
            // list播放完毕
            return {
                canPlayNext: false,
                message: "Playlist over>>>, total len: ', ".concat(this.player.videoInfos.length),
            };
        }
        return {
            canPlayNext: true,
            message: "checkPlayNext(), curUrlIdx=".concat(this.player.curUrlIdx, "/urlLength=").concat(this.player.videoInfos.length, "/")
                + "nextStartTime: ".concat(this.player.nextVideoInfo.playtime),
        };
    };
    /**
     * 检查是否自动预加载下一个视频
     * @param leftTime 离上一个视频播放的结束时间
     * @returns {canPreload:boolean,message:string} 是否可预加载下一个视频
     */
    CheckPlayerStatus.prototype.checkAutoPreloadNext = function (leftTime) {
        var _a;
        if (!((_a = this.player) === null || _a === void 0 ? void 0 : _a.currentVideoInfo)) {
            return {
                canPreload: false,
                message: 'Player or player.currentVideoInfo is null',
            };
        }
        if (!this.player.nextVideoInfo || this.player.preloadVideoInfos.indexOf(this.player.nextVideoInfo) !== -1) {
            return {
                canPreload: false,
                message: 'nextVideoInfo is null or nextVideoInfo is already preload now',
            };
        }
        var autoPreloadLeftTime = this.player.currentVideoInfo.config.autoPreloadLeftTime;
        if (autoPreloadLeftTime <= 0) {
            return {
                canPreload: false,
                message: 'Can not preload,autoPreloadLeftTime <= 0',
            };
        }
        // 如果指定的时间大于等于时长，那么只要当前视频时间大于0就会尝试预加载下一个
        if ((autoPreloadLeftTime >= this.player.currentVideoInfo.duration && this.player.currentVideoInfo.playtime > 0)
            || autoPreloadLeftTime >= leftTime) {
            return {
                canPreload: true,
                message: 'Can preload now',
            };
        }
        return {
            canPreload: false,
            message: 'Can not preload,autoPreloadLeftTime is illegal',
        };
    };
    /** 销毁 */
    CheckPlayerStatus.prototype.destroy = function () {
        this.player = null;
    };
    return CheckPlayerStatus;
}());
export default CheckPlayerStatus;
